import { createRouteRef } from '@backstage/core-plugin-api';

/**
 * A Backstage RouteRef for the User Settings page.
 * @public
 */
export const userSettingsRouteRef = createRouteRef({
  id: 'user-settings',
});
